import { PrimaryButton, PrimaryButtonProps, useOverflowStatus } from '@atlaskit/atlassian-navigation';
import { ButtonItem } from '@atlaskit/menu';
import React, { ComponentType } from 'react';

const NavPrimaryMenuButton: ComponentType<PrimaryButtonProps & { handleOnClick: () => void }> = props => {
  const { children, handleOnClick, ...rest } = props;
  const overflowStatus = useOverflowStatus();

  return overflowStatus.isVisible ? (
    <PrimaryButton onClick={handleOnClick} {...rest}>
      {children}
    </PrimaryButton>
  ) : (
    <ButtonItem onClick={handleOnClick}>{children}</ButtonItem>
  );
};

export default NavPrimaryMenuButton;
